import React from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Helmet } from "react-helmet-async"
import * as S from './SeoPageHeaderUI.styles';
import BreadCrumbs from '../../../../../stories/components/cars/SeoPage/BreadCrumbs/BreadCrumbs';
import { SeoMetaSelector, breadCrumbsSelector, rentalDataSelector, lpgSelector, placeInformationSelector, seoContentSelector,pageTypeSelector, templatizedContentSelector, routeInfoDataSelector, seoInboundCallSelector, seoInboundContactNumber } from '../../redux/selector';
import CollapsableContainer from '../../../../../stories/core-components/CollapsableContainer/CollapsableContainer';
import TopRoutes from '../../../../../stories/components/cars/SeoPage/TopRoutes/TopRoutesWrapper';
import {
    sourceSelector,
    destinationSelector,
} from "../../../../common/redux/selector";
import { capitalizeFirstLetter, getSubtitleForAvailableCabs, getTitleForAvailableCabs } from '../../../../config/utils';
import useNavigate from '../../../../hooks/useNavigate';
import { UPDATE_PAYDATA, UPDATE_SELECTED_CAB } from '../../redux/seo-action-types';
import RouteInfo from '../../../../../stories/components/cars/SeoPage/RouteInfo/RouteInfo';

export default function({charDham = false}) {
    const seoMeta = useSelector(SeoMetaSelector);
    const breadCrumbsData = useSelector(breadCrumbsSelector);
    const rentalData = useSelector(rentalDataSelector);
    const source = useSelector(sourceSelector);
    const destination = useSelector(destinationSelector);
    const lpg = useSelector(lpgSelector);
    const placeInformation = useSelector(placeInformationSelector);
    const seoContent = useSelector(seoContentSelector);
    const templatizedContent = useSelector(templatizedContentSelector);
    const pageType = useSelector(pageTypeSelector);
    const routeInfoData = useSelector(routeInfoDataSelector);
    const showInboundCall = useSelector(seoInboundCallSelector);
    const contactNumber = useSelector(seoInboundContactNumber);
    const dispatch = useDispatch();
    const [navigateTo] = useNavigate();

    const parseRoutes = (routes) => {
        if (routes && routes?.length > 0) {
            return routes.map((route) => {
                return {
                    title: route?.source && route?.destination ? `${capitalizeFirstLetter(route?.source)} to ${capitalizeFirstLetter(route?.destination)} cabs` : '',
                    subtitle: route?.distance && route?.approx_time ? `${route?.distance} kms | ${route?.approx_time} (appx.)` : '',
                    includedDistance: route?.included_distance ? `${route?.included_distance} kms included` : '',
                    extraFare: route?.extra_fare && route?.distance ? `Extra fare ₹${route?.extra_fare}/km after ${route?.distance} kms` : '',
                    startingPrice: route?.starting_price,
                    src_id: route?.source_city_id,
                    dest_id: route?.destination_city_id,
                    source: route?.source,
                    destination: route?.destination,
                    isLPG: !!route?.isLPG,
                    toolTip: !!route?.isLPG ? lpg : {},
                    car_types: route?.car_types || "",
                    img_url: route?.img_url || "",
                    vehicle_key: route?.vehicle_key || "",
                    car_types_subtitle: route?.car_types_subtitle || "",
                    d_s: route?.d_S || ""
                }
            })
        }
        return [];
    }

    const reviewAction = (route) => {
        dispatch({
            type: UPDATE_PAYDATA,
            paydata: {}
        });
        dispatch({
            type: UPDATE_SELECTED_CAB,
            selectedCab: { key: route?.vehicle_key, dispatchSearchId: '', vehicle_type: route?.key },
        });
        navigateTo('seo-to-review');
    }
    return (
        <React.Fragment>
            <Helmet
                title={seoMeta?.meta_title}
                meta={[
                    { name: 'description', content: seoMeta?.meta_description },
                    { name: 'keywords', content: seoMeta?.meta_keywords },
                    { property: 'og:title', content: seoMeta?.meta_title },
                    { property:'og:description', content: seoMeta?.meta_description },
                    { property:'og:url', content: seoMeta?.canonical_url }
                ]}
                link={[
                    {
                        href: seoMeta?.canonical_url,
                        rel: 'canonical',
                    },
                    {
                        href: seoMeta?.alternate || "",
                        rel: 'alternate',
                    },
                ]}
            />
            <BreadCrumbs breadCrumbs={breadCrumbsData} showInboundCall={showInboundCall} contactNumber={contactNumber}/>
            <S.TitleWrapper>
                {seoMeta?.h1_title && <S.Title>{seoMeta?.h1_title}</S.Title>}
                {seoMeta?.meta_description ? charDham ? (
                        <React.Fragment>
                            <Helmet>
                                <meta name="description" content={seoMeta?.meta_description} />
                            </Helmet>
                        </React.Fragment>)
                : (
                    <CollapsableContainer containerHeight="5rem" shadowColor="#eef4fd">
                        <React.Fragment>
                            <S.Subtitle>{seoMeta?.meta_description}</S.Subtitle>
                            <S.DynamicContentCont>
                                <S.StaticContent dangerouslySetInnerHTML={{ __html: templatizedContent }} /> 
                            </S.DynamicContentCont>
                            <RouteInfo
                              title={routeInfoData?.title}
                              routeInfo={routeInfoData?.table}
                            />
                            <S.DynamicContentCont>
                                <S.StaticContent dangerouslySetInnerHTML={{ __html: seoContent }} /> 
                            </S.DynamicContentCont>
                            <TopRoutes
                                routes={parseRoutes(rentalData)}
                                title={getTitleForAvailableCabs(pageType, source, destination)}
                                onAction={(route) => reviewAction(route)}
                                isCarType
                                subtitle={getSubtitleForAvailableCabs(source?.name, destination?.name, 'Cab')}
                                tableThirdColHeading={`${pageType ? getSubtitleForAvailableCabs(source?.name, destination?.name, 'Cab Price') : ''}`}
                            />
                            <S.PlaceInformationContent>
                                <S.StaticContent dangerouslySetInnerHTML={{ __html: placeInformation }} />
                            </S.PlaceInformationContent>
                            
                        </React.Fragment>
                    </CollapsableContainer>
                ):null}
            </S.TitleWrapper>
        </React.Fragment>
    )
}